module.exports = __webpack_public_path__ + "console/img/快递运输.c75dcd57.png";